import * as actions from "../actions/notificationSettings";
import { setSafe } from "../util/storeHelper";
export const notificationSettingsReducer = {
    reducers: {
        [actions.suppressNotification]: (state, payload) => setSafe(state, ["suppress", payload.id], payload.suppress),
        [actions.resetSuppression]: (state) => setSafe(state, ["suppress"], {}),
    },
    defaults: {
        suppress: {},
    },
};
